export default __webpack_public_path__ + "static/media/cardFname_info.8b1eacfe.png";